import imagesLoaded from 'imagesloaded';
import Modal from './module.modal';
import Carousel from './module.carousel';
import Modules from '../helpers/born.modules';
import {createElWithAttrs} from '../helpers/born.utils';

/**
 * gallery: String | Node. Selector or element to use as gallery container.
 */

export default class GalleryZoom {
	constructor(options) {
		this.options = options || {};

		this.options.type        = this.options.type        || 'slick';
		this.options.modalclass  = this.options.modalclass  || 'modal--pdp-zoom';
		this.options.modalID     = this.options.modalID     || 'overlay--pdp-zoom';

		if(this.options.type === 'slick') {
			this._$sourceGallery = $(this.options.gallery);
			this._itemList = this._$sourceGallery[0].querySelectorAll(this.options.items);
			this.setHandlers();
		}
	}

	setHandlers() {
		//Needs to be attached to the container, and not specific items if its a carousel because otherwise it screws with Slick's swiping mechanism
		this._$sourceGallery.off('.openZoom')
			.on('click.openZoom', this.setupZoomedSlider.bind(this))
			.on('click.openZoom', function (e) {
				const target = $(e.target);
				!target.is('video') && !target.hasClass('video--playwrap') && $(this).trigger('galleryZoomStart');
		});
	}

	setupZoomedSlider(e) {
		if( !this.options.useTrigger || (this.options.useTrigger && e.target.hasAttribute('data-zoom-trigger')) ) {
			let linkedModal = Modal.exists(this.options.modalID),
				targetIndex = [].indexOf.call(this._itemList, e.target);

			//Save the clicked element's index to use it when sliderSyncing is turned off.
			this.triggerTargetIndex = targetIndex !== -1 ? targetIndex : 0;

			if( !linkedModal ) {
				this.renderModal(this.createSliders());
			}

			else {
				Modal.openModal(linkedModal);
			}
		}
	}

	createSliders() {
		let zContainer       = this.createLayout(),
			zGallerySettings = JSON.stringify(this.options.gallerySlick || ''),
			zThumbsSettings  = JSON.stringify(this.options.thumbsSlick  || '');

		this._zGalleryClass = 'zoom__gallery';
		this._zThumbsClass  = 'zoom__thumbnails';

		let zThumbsSlider  = createElWithAttrs(zContainer.thumbsColumn, {'class': this._zThumbsClass + ' slick--visible', 'data-slick': zThumbsSettings}),
			zGallerySlider = createElWithAttrs(zContainer.galleryColumn, {'class': this._zGalleryClass + ' slick--visible slick--preloaded slick--wide-arrows slick--hover-arrows', 'data-slick': zGallerySettings, 'data-slick-sync': '#modal-'+ this.options.modalID +' .' + this._zThumbsClass});

		[].forEach.call(this._itemList, (item) =>{
			zThumbsSlider.appendChild(this.createSliderItem(item));
			zGallerySlider.appendChild(this.createSliderItem(item, true));
		});

		return zContainer.wrapper;
	}

	createLayout() {
		let wrapper = createElWithAttrs(false, {'class': 'zoom-row max-width--site gutter-padding row row-sm--fluid'});

		if(this.options.type === 'slick') {
			return {
				wrapper: wrapper,
				thumbsColumn: createElWithAttrs(wrapper, {'class': 'col-lg-1 col-md-2 col-sm--fluid display--small-up'}),
				galleryColumn: createElWithAttrs(wrapper, {'class': 'col-md-8 col-xs-12 col-sm--fluid'})
			};
		}

		return wrapper;
	}


	createSliderItem(item, isMainItem) {
		let videoSettings = item.getAttribute('data-video'),
			zoomItem = document.createElement('div');

		if( videoSettings && isMainItem ) {
			if(item.nodeName === 'VIDEO') {
				let videoEl = createElWithAttrs(zoomItem, {'data-video': videoSettings, 'poster': item.getAttribute('poster'), 'loop': item.getAttribute('loop') !== 'false' ? true : false, 'muted': item.hasAttribute('muted') !== 'false' ? true : false,'controls':true,'controlslist':'nodownload'}, 'video');

				[].forEach.call(item.querySelectorAll('source'), function(source){
					videoEl.appendChild(source.cloneNode());
				});

				if (videoSettings) {
					zoomItem.classList.add('video--playwrap', 'video--playwrap--thumb');
				}
			}

			else {
				createElWithAttrs(zoomItem, {'data-video': videoSettings, 'class': (item.video.options.youtubeID ? 'video--wide-format' : '' )});
			}
		}

		else {
			let source;

			if( isMainItem ) {
				source = item.getAttribute('data-high-res');
			}

			else if (videoSettings) {
				zoomItem.classList.add('video--playwrap', 'video--playwrap--thumb');
				source = item.getAttribute('poster');
			}

			else {
				source = item.src ? item.src : item.getAttribute('data-lazy');
			}

			createElWithAttrs(zoomItem, {'src': source}, 'img');
		}

		return zoomItem;
	}

	goToSlide(overlay) {
		if(this.$zoomGallery.hasClass('slick-initialized')) {
			let openAtIndex = this.options.sliderSyncing ? this._$sourceGallery.slick('slickCurrentSlide') : this.triggerTargetIndex;

			$(overlay).imagesLoaded(() => {
				this.$zoomGallery.slick('slickGoTo', openAtIndex, true);
			});
		}
	}

	renderModal(content) {
		let scope = this;

		this.modal = new Modal({
			modalID: scope.options.modalID,
			overlayClass: 'fullscreen',
			modalClass: scope.options.modalclass,
			modalContent: content,
			afterCreateCallback: function(overlay) {
				scope.$zoomGallery = $(overlay.querySelector('.' + scope._zGalleryClass));

				//This is required to trigger slick's goto properly
				scope.$zoomGallery.on('init', scope.goToSlide.bind(scope, overlay));

				Modules.carousel.init();
			},
			afterOpenCallback: this.goToSlide.bind(this),
			afterCloseCallback: function(overlay) {
				//Use Carousel methods to pause videos on the modal
				[].forEach.call(Carousel.getPreviousVideos(scope.$zoomGallery[0]), Carousel.pausePrevious);

				if(scope.options.sliderSyncing) {
					scope._$sourceGallery.slick('slickGoTo', scope.$zoomGallery.slick('slickCurrentSlide'), true);
				}
			}
		});
	}
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.zoom.js